import { ICommand } from './../../../../vendor/core-ts-types/dist/main';
import { IChecklistItemStrategy } from './../../strategies/checklist_item_strategy';
import { Strategy } from 'utility-ts-strategy';
import { ChecklistItemStatus, IChecklistItem } from '../../types/checklist_types';

export interface IChecklistCardScope extends ng.IScope {
  item: IChecklistItem;
  onTransition: () => void;
  cancelTransition: () => void;
}

export class ChecklistCardController {
  private cardStrategy: IChecklistItemStrategy;
  private __$self: HTMLElement;

  constructor(
    private $scope: IChecklistCardScope,
    private $element: HTMLElement[],
    private selectChecklistItemCommand: ICommand,
    ngChecklistItemStrategy: Strategy<IChecklistItemStrategy>
  ) {
    this.cardStrategy = ngChecklistItemStrategy[$scope.item.status];

    this.__$self = $element[0];
  }

  viewDetails(item: IChecklistItem) {
    return this.selectChecklistItemCommand(item);
  }

  onTransition($event: Event) {
    this.$scope.onTransition();
    this.__$self.focus();
  }

  cancelTransition() {
    this.__$self.focus();
    this.$scope.cancelTransition();
  }
}

angular
  .module('capability-ng-checklist')
  .controller('ngChecklistCardController', ChecklistCardController)
  .directive('checklistCard', () => {
    return {
      templateUrl: 'lib/checklist/components/checklist_card/checklist_card.html',
      controller: 'ngChecklistCardController',
      controllerAs: '$ctrl',
      scope: {
        item: '<',
        onTransition: '&',
        cancelTransition: '&'
      }
    };
  });



// WEBPACK FOOTER //
// ./app/lib/checklist/components/checklist_card/checklist_card.ts